/**
 * Pieces shared by the MCP server page and the MCP Help topic (#939, Features F and G), so the
 * scope table and the tool-permission wording can't drift apart.
 */
import { ToolPermissionLabel } from "./ToolPermissionIcon";
import styles from "./McpShared.module.css";

/** "allow, ask or block", each with Claude's icon. */
export function ToolPermissionChoices() {
  return (
    <>
      <ToolPermissionLabel kind="allow" lowercase className={styles.permLabel} />,{" "}
      <ToolPermissionLabel kind="ask" lowercase className={styles.permLabel} /> or{" "}
      <ToolPermissionLabel kind="block" lowercase className={styles.permLabel} />
    </>
  );
}

/** Where `claude mcp add --scope` puts a server, and who gets it. */
export function ClaudeCodeScopeTable() {
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th scope="col">Scope</th>
          <th scope="col">Where it lands</th>
          <th scope="col">Who gets it</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><code className={styles.inlineCode}>local</code> (default)</td>
          <td>Your machine, this project</td>
          <td>Just you, here</td>
        </tr>
        <tr>
          <td><code className={styles.inlineCode}>user</code></td>
          <td>Your machine, all projects</td>
          <td>Just you, everywhere</td>
        </tr>
        <tr>
          <td><code className={styles.inlineCode}>project</code></td>
          <td>The repo&rsquo;s <code className={styles.inlineCode}>.mcp.json</code></td>
          <td>Everyone who clones the repo</td>
        </tr>
      </tbody>
    </table>
  );
}
